import { useAccount } from '@azure/msal-react';

export const useInRole = (roles: string[]): boolean => {
	const account = useAccount();
	const idTokenClaims = account?.idTokenClaims?.roles ?? [];
	return idTokenClaims.some(role => roles.includes(role));
};
